
/**
 * 알림 기본 정보
 */
export type GetNotificationById200BasicInfoAllOfTwo = {
  /** 알림 내용 */
  content: string;
  /** 알림 유형 (LIKE, FOLLOW, MENTION, REPLY, RETWEET, SYSTEM) */
  type: string;
  /** 알림을 받는 사용자 ID */
  userId: number;
};
